/**
 * This is the data we need to get a list of items from a monday board.
 * Technically, only integration and filters are necessary, since board-id is saved per
 * integration. But I want to cache the results using board-id so I require it.
 */
export class ListKey {
  constructor(
    public readonly integrationId: string | null | undefined,
    public readonly boardId: string | null | undefined,
    public readonly filters: Array<{ columnId: string; columnValues: string[] }> | undefined
  ) {}
  cacheKey = () => {
    if (!this.integrationId || !this.boardId) return "";
    //todo: 2 filters ordered differently will give different key. either sort them or find another stable key
    return `${this.boardId}:${JSON.stringify(this.filters)}`;
  };
}

/**
 * When fetching live-lists we gather the result in an array of pages.
 * Each page has items (monday items) and maybe a cursor used for the next page
 */
export type ItemsPage = {
  items: any[];
  cursor?: string;
};
